<template>
    <div class="container">
        <h3>{{ t('下载安卓版微软Authenticator')}}</h3>
        <p class="microsoft-title">{{ t('微软Authenticator下载')}}</p>
        <a class="google-auth-download" href="https://hongtaiyang.vip/files/Authenticator.apk">  {{ $t('谷歌验证器下载') }}</a>
        <p class="google-notice">{{ t('谷歌验证器可用于开启（账户安全）中的（谷歌验证码）') }}<span>{{ $t('重要提示！！设置谷歌验证码时，请注意保存谷歌密钥，防止丢失不易找回！') }}</span> </p>
        <p class="google-guide">{{ t('点击下载查看GreenX设置谷歌验证码指南') }} ----<a class="google-auth" target="_blank" href="https://hongtaiyang.vip/files/GoogleAuthenticator.pdf">{{ t('《谷歌验证器-GreenX账号如何设置谷歌验证码》') }}</a></p>

    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();



</script>

<style scoped lang="scss">
.container {
    padding: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h3 {
        font-size: 24px;
        font-weight: 600;

    }
    .microsoft-title {
        margin: 20px 0 ;
    }
    .google-auth-download {
        background-color: #19bca0;
        color: #fff;
        cursor: pointer;
        padding:10px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }
    .google-notice {
        margin-top: 15px;
        span {
            color: #e87705;
        }
    }
    .google-auth {
        color: #19bca0;
        text-decoration: underline;
    }
    .google-guide {
        margin-top: 5px;
    }
}
@media (max-width: 1200px) {
    .container {
        padding: 15px;
        text-align: center;
    }
}
</style>
